import React, { ChangeEvent } from 'react';
import { CommonSelectProps, SelectOption } from '../../../types/common';

export const DropdownTestId = 'dropdown-input';

type DropdownProps = CommonSelectProps;

const Dropdown: React.FC<DropdownProps> = ({
  name,
  displayText,
  options,
  hasErrors,
  className = '',
  autoComplete,
  defaultValue,
  disabled = false,
  readOnly = false,
  register,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
}: DropdownProps) => {
  const classes = `${className}
    pt-5 w-full pl-4 pb-1
    border-1-half rounded border-transparent
    focus:border-[color:var(--form-accent-color)] outline-none pl-3
    bg-gray-50 cursor-pointer appearance-none ${
      hasErrors ? 'input-error-border' : ''
    } ${readOnly ? 'pointer-events-none' : 'pointer-events-auto'}`;

  if (!register) {
    return (
      <select
        id={name}
        name={name}
        className={classes}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        autoCorrect="off"
        autoComplete={autoComplete}
        data-testid={DropdownTestId}
        defaultValue={defaultValue}
        disabled={disabled}
        onChange={onChange}
      >
        <option disabled className="capitalize">
          {displayText || name}
        </option>
        {options.map(({ value, label }: SelectOption) => {
          return (
            <option key={`${label}-${value}`} value={value}>
              {label}
            </option>
          );
        })}
      </select>
    );
  }

  const { onChange: rhfOnChange, ...rest } = register?.(name) ?? {};

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    rhfOnChange?.(event);
    onChange?.(event);
  };

  return (
    <select
      id={name}
      className={classes}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      autoCorrect="off"
      autoComplete={autoComplete}
      data-testid={DropdownTestId}
      defaultValue={defaultValue}
      disabled={disabled}
      onChange={handleOnChange}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      <option disabled className="capitalize">
        {displayText || name}
      </option>
      {options.map(({ value, label }: SelectOption) => {
        return (
          <option key={`${label}-${value}`} value={value}>
            {label}
          </option>
        );
      })}
    </select>
  );
};
export default Dropdown;
